import React, { Component } from 'react'
import { Row, Col, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { purchaseVip } from "../../graphqlDic";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as PurchaseVipConst from '../../constants/PurchaseVip';
import { Link } from 'react-router-dom';
import { callChange } from './../../helpers/ApiPayment';

class AccountVip extends Component {
    constructor() {
        super();
        this.state = { tabIndex: 0 };
    }

    notify = (msg) => toast.info(msg);
    
    handleSubmit = () => {
        let { user_info } = this.props;

        if (user_info.is_vip) {
            this.notify("Tài khoản của bạn đã là VIP!");
        } else {
            if (user_info.scoin >= PurchaseVipConst.VIP) {
                this.props.purchaseVip({
                    variables: {
                        user_id: parseInt(user_info.id, 10)
                    }
                }).then((data) => {
                    let result = data.data.purchaseVip;
                    if (result.is_vip) {
                        let data = {};
                        data.email = user_info.email;
                        data.value = -Math.abs(PurchaseVipConst.VIP); // negative-number
                        data.ordercode = Date.now();
                        let result = callChange(data);
                            result.then(
                                window.location.reload()
                            ).catch(console.log)
                    } else {
                        this.notify("Mua tài khoản VIP thất bại");
                    }
                })
                .catch(error => {
                    console.log(error)
                });
               
            } else {
                this.notify("Tài khoản của bạn không đủ scoin!");
            }
        }
    }

    render() {
        let { user_info } = this.props;
        return (
            <div className="block-vip">
                <div className="top"></div>
                <div className="text-center text-group1">
                    <div className="title">Tài khoản <img src="images/vip1.png" alt="" /></div>
                    <div className="">Tài khoản VIP giúp bạn nhận được nhiều ưu đãi và tiện ích khi xem tại PEGATV</div>
                </div>
                <ul className="list-inline text-center list-intro-vip">
                    <li>
                        <div className="icon"><img src="images/icon-vip1.png" alt="" /></div>
                        <div className="text"><img src="images/icon-narrow.png" alt="" />Xem Showtv và các kênh truyền
                            hình nước ngoài.</div>
                    </li>
                    <li>
                        <div className="icon"><img src="images/icon-vip2.png" alt="" /></div>
                        <div className="text"><img src="images/icon-narrow.png" alt="" />Thưởng thức những Bộ Fill với độ
                            phân giải Full HD.</div>
                    </li>
                    <li>
                        <div className="icon"><img src="images/icon-vip3.png" alt="" /></div>
                        <div className="text"><img src="images/icon-narrow.png" alt="" />Xem Film, TV trên server VIP với
                            tốc độ cao</div>
                    </li>
                    <li>
                        <div className="icon"><img src="images/icon-vip4.png" alt="" /></div>
                        <div className="text"><img src="images/icon-narrow.png" alt="" />Không hiển thị quảng cáo trên
                            trang</div>
                    </li>
                </ul>
                <div className="choose-text">
                    <div className="top"></div>
                    <div className="main">
                        <div className="title1">Chọn phương thức nạp</div>
                        <div className="title2">Hãy chọn một phương thức nạp vip bên dưới đẻ tiếp tục</div>
                    </div>
                </div>

                <Tabs className="choose-method" selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                    <div className="container">
                        <TabList className="list-inline text-center marginB0  list-control">
                            <Tab className={this.state.tabIndex === 0 ? "active" : ""}><a>Mã code VIP</a></Tab>
                            <Tab className={this.state.tabIndex === 1 ? "active" : ""}><a>Thẻ Visa, Master</a></Tab>
                            <Tab className={this.state.tabIndex === 2 ? "active" : ""}><a>Thẻ ngân hàng nội địa</a></Tab>
                            <Tab className={this.state.tabIndex === 3 ? "active" : ""}><a>Thẻ điện thoại, Game</a></Tab>
                            <Tab className={this.state.tabIndex === 4 ? "active" : ""}><a>Tin nhắn SMS</a></Tab>
                            <Tab className={this.state.tabIndex === 5 ? "active" : ""}><a>Dùng Scoin</a></Tab>
                        </TabList>
                    </div>
                    <div className="main-control">
                        <TabPanel className="tab-content container">
                            <div className="tab-pane fade in active" id="pay1">
                                <div className="form-group">
                                    <h2 className="text-gray">Nhập mã kích hoạt</h2>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                                        <input type="text" className="form-control" placeholder="Eg: xxxx-xxxx" />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-1">
                                        <button className="form-control btn btn-primary">Kích hoạt</button>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel className="container">
                            <div role="tabpanel" className="tab-pane" id="pay2">
                                <div className="form-group">
                                    <h2 className="text-gray">Nạp VIP bằng thẻ Visa hoặc thẻ Master</h2>
                                </div>
                                <div className="form-group">
                                    <div className="text-danger-kt">Chú ý: Chỉ chấp nhận thẻ Visa/Master/JCB do ngân hàng
                                        Việt Nam phát hành.
                                </div>
                                </div>
                                <div className="form-group">
                                    <h4 className="text-muted">Chọn mệnh giá nạp</h4>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                                        <input type="text" className="form-control" placeholder="Eg: xxxx-xxxx" />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-1">
                                        <button className="form-control btn btn-primary">Kích hoạt</button>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel className="container">
                            <div role="tabpanel" className="tab-pane" id="pay3">
                                <h2 className="text-gray text-center">Phương thức thanh toán này đang phát triển</h2>
                            </div>
                        </TabPanel>
                        <TabPanel className="container">
                            <div role="tabpanel" className="tab-pane" id="pay4">
                                <h2 className="text-gray text-center">Phương thức thanh toán này đang phát triển</h2>
                            </div>
                        </TabPanel>
                        <TabPanel className="container">
                            <div role="tabpanel" className="tab-pane" id="pay5">
                                <h2 className="text-gray text-center">Phương thức thanh toán này đang phát triển</h2>
                            </div>
                        </TabPanel>
                        <TabPanel className="container">
                            <div role="tabpanel" className="tab-pane" id="pay6">
                                <Row>
                                    <Col>
                                        <ToastContainer />
                                        <div className="text-uppercase user-info-heading"><i className="fa fa-lg fa-check-square text-danger"></i>{' '}Thông tin tài khoản</div>
                                        <ListGroup>
                                            <ListGroupItem><strong>- EMAIL CỦA BẠN: </strong><span className="text-danger">{user_info.fullname}</span></ListGroupItem>
                                            <ListGroupItem><strong>- SỐ DƯ TÀI KHOẢN: </strong><span className="text-danger">{user_info.scoin} scoin</span></ListGroupItem>
                                            <ListGroupItem><strong>- LOẠI TÀI KHOẢN: </strong><span className="text-danger">{user_info.is_vip ? 'VIP' : 'Thường'}</span></ListGroupItem>
                                        </ListGroup>
                                        <div className="text-uppercase"><i className="fa fa-lg fa-check-square text-danger"></i>{' '}Điều kiện nạp VIP</div>
                                        <div>
                                            <ListGroup>
                                                <ListGroupItem>Số dư scoin phải lớn hơn hoặc bằng {PurchaseVipConst.VIP}</ListGroupItem>
                                                <ListGroupItem>Tài khoản của bạn chưa phải là tài khoản VIP</ListGroupItem>
                                            </ListGroup>
                                        </div>
                                        {JSON.stringify(user_info) === '{}' ?
											<Link to='/login' className="payment-button btn btn-secondary">Đăng Nhập</Link>
											: null
										}
                                        {JSON.stringify(user_info) !== '{}' && !user_info.is_vip ?
                                            <Button outline size="sm" color="primary" onClick={this.handleSubmit} className="purchase-vip mb-2 mt-1">Click vào đây để mua tài khoản VIP</Button> :
                                            null
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </TabPanel>
                    </div>
                </Tabs>


            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user_info: state.root.users
    }
}

export default compose(graphql(
    purchaseVip, {
        name: 'purchaseVip'
    })
)(connect(mapStateToProps, null)(AccountVip));


// WEBPACK FOOTER //
// ./src/components/AccountVip/AccountVip.js